import lang from './vi-vn.json';

export function translate(key) {
    return lang[key];
}
